import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PublicInquiryComponent } from './pages/public/inquiry/public-inquiry/public-inquiry.component';

const routes: Routes = [
  {
    path: 'main',
    canActivate: [AuthGuard],
    canMatch: [AuthGuard],
    loadChildren: () => import('./pages/main/main.module').then((m) => m.MainModule)
  },
  {
    path: 'inquiry',
    component: PublicInquiryComponent,
    children: [{ path: '**', redirectTo: '' }],
  },
  { path: '', loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule) },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Add options right here
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
